import { ITypeRequest } from '../../../../../../../../theme/ui/Dashboard/Dashboard.model';
import StructureAPI from '../../../../../../../../redux/structure/StructureAPI';

interface IUseStructuresWorkspaceProps {
  typeRequest: ITypeRequest;
  workspaceId?: string;
}
function useStructuresWorkspace(props: IUseStructuresWorkspaceProps) {
  const { typeRequest, workspaceId } = props;

  return StructureAPI.endpoints.getStructureV2.useQuery(workspaceId, {
    skip: typeRequest === 'workspaces',
  });
}

export default useStructuresWorkspace;
